export const GET_CUSTOMERS = 'GET_CUSTOMERS';
export const FILTER_CUSTOMERS = 'FILTER_CUSTOMERS';
export const ADD_CUSTOMER = 'ADD_CUSTOMER';
export const EDIT_CUSTOMER = 'EDIT_CUSTOMER';
export const GET_CUSTOMER = 'GET_CUSTOMER';
export const RESET_CUSTOMER = 'RESET_CUSTOMER';
export const CUSTOMERS_ERROR = 'CUSTOMERS_ERROR';
